<template>
  <div class="myInvite">
     <img
        class="back"
        @click="goHome"
        v-lazy="require('./../../../assets/img/back2.png')"
      />
    <van-tabs v-model="activeName">
      <van-tab :title="'邀请好友'" name="a">
        <div class="invite_box">
          <div ref="saveDiv" v-show="firstFlag">
            <div class="invite_userinfo">
              <div class="invite_userinfo_left">
                <div class="invite_userinfo_av">
                  <img v-lazy="user.avatar" alt="" />
                </div>
                <p class="name f16">
                  {{
                    user.nick_name && user.nick_name.length > 10
                      ? user.nick_name.slice(0, 10) + "..."
                      : user.nick_name
                  }}
                  <span v-if="isVip" class="vip ml-5"></span>
                  <span v-if="!isVip" class="vip-no ml-5"></span>
                </p>
              </div>
              <!-- <div class="invite_userinfo_right" @click="handleShowSave()">
                下载
              </div> -->
            </div>
            <div class="invite_code_box">
              <div ref="qrCode" class="invite_code"></div>
              <p class="invite_code_de">邀请好友一起体验“酷炫脑测评”吧</p>
            </div>
            <div class="content">
              <input
                v-model="user.invite_code"
                class="content_Icode"
                :style="{ color: success ? '#417505' : '' }"
                readonly
              />
              <van-icon name="success" v-if="success" class="rightIcon" />

              <van-button
                type="default"
                v-clipboard:copy="
                  'http://h5.coolbrainscience.cn/#/index/' + user.invite_code
                "
                v-clipboard:success="copy"
                v-clipboard:error="copyError"
                class="bgblue content_copy"
                >{{ this.success ? "完成" : "复制" }}</van-button
              >
            </div>
          </div>
          <img
            v-lazy="imgData"
            ref="resImg"
            v-show="!firstFlag"
            class="savePic"
          />
        </div>
      </van-tab>

      <van-tab :title="'邀请列表'" name="b" @click="getroadList()">
        <NoPic style="margin-top: 50%" v-if="!len"></NoPic>
        <div
          v-for="(item, index) in inviteList"
          :key="index"
          class="list mt-20"
        >
          <img v-lazy="item.avatar" class="ml-20" />
          <p class="f16">
            {{ item.nick_name }}
            <span v-if="item.is_vip.key === 'yes'" class="vip"></span>
            <span v-if="item.is_vip.key !== 'yes'" class="vip-no"></span>
          </p>
          <hr v-if="index !== inviteList.length - 1" />
        </div>
      </van-tab>
    </van-tabs>
  </div>
</template>

<script>
import { getMyInvite, getUserInfo } from "@/http/api";
import NoPic from "@/components/NoPic";
import store from "./../../../store/index";
import { mapGetters } from "vuex";
import html2canvas from "./../../../utils/html2canvas";
import QRCode from "qrcodejs2";
export default {
  name: "invite",
  data() {
    return {
      activeName: "a",
      len: 0,
      inviteList: [],
      isVip: false,
      code: "",
      success: false,
      codeGirlImg: require("../../../assets/img/test/code_girl.png"),
      // 分页
      total: 0,
      pageSize: 10, // 每页条数
      pageIndex: 1, // 页码
      isDownLoading: false, // 下拉刷新
      isUpLoading: false, // 上拉加载
      upFinished: false, // 上拉加载完毕
      offset: 100, // 滚动条与底部距离小于 offset 时触发load事件
      showSave: false,
      firstFlag: true,
      imgData: "",
    };
  },
  computed: {
    ...mapGetters(["user"]),
  },
  mounted() {
    console.log("用户", this.user);
    this.$nextTick(() => {
      this.bindQRCode();
    });
  },
  created() {
    let pro = this.user;
    this.getroadList();
    getUserInfo(pro.user).then((res) => {
      console.log(res);
      const payload = res.data.profile;
      store.commit("updateUser", payload);
      if (payload.is_vip.key === "yes") {
        this.isVip = true;
        // localStorage.setItem('vipPopShow', new Date().getDate())
      }
    });
  },
  updated() {},
  methods: {
    goHome() {
      this.$router.push("/my/center");
    },
    handleShowSave() {
      this.$router.push("./inviteSave");
    },
    gomycode() {
      this.$router.push("./mycode");
    },
    // 复制兑换码
    copy(e) {
      console.log("复制成功", e);
      this.success = true;
    },
    copyError(e) {
      console.log("复制失败", e);
      this.success = false;
    },
    // 生成二维码
    bindQRCode() {
      let t = this;
      console.log(this.$refs.qrCode);
      new QRCode(this.$refs.qrCode, {
        text: "http://h5.coolbrainscience.cn/#/index/" + this.user.invite_code, // 二维码网址:酷炫脑首页+邀请码
        width: this.$refs.qrCode.clientWidth - 20,
        height: this.$refs.qrCode.clientHeight - 20,
        colorDark: "#000", // 二维码颜色
        colorLight: "#ffffff", // 二维码背景色
        correctLevel: QRCode.CorrectLevel.L, // 容错率，L/M/H
      });
      this.createPicture();
    },
    createPicture() {
      let content = this.$refs.saveDiv;
      let width = content.offsetWidth;
      let height = content.offsetHeight;
      let scale = window.devicePixelRatio;
      // console.log(width, height, scale)
      let opt = {
        // scale: scale,
        useCORS: true,
        tainttest: true,
        allowTaint: true,
        backgroundColor: "#fff",
        width: width,
        height: height * 1.6,
      };
      html2canvas(this.$refs.saveDiv, opt).then((canvas) => {
        var imgData = canvas.toDataURL("image/jpeg");
        this.imgData = imgData;
        let resDom = this.$refs.resImg;
        resDom.style.width = width * scale;
        resDom.style.height = height * scale;
        // console.log(resDom)

        // console.log('canvas',canvas)
      });
    },
    // 下载二维码图片
    downloadPic() {
      this.$router.push("./mycode");
    },
    getroadList() {
      let params = {
        page: this.pageIndex,
        page_size: this.pageSize,
      };
      getMyInvite(params)
        .then((res) => {
          console.log("我的邀请", res);
          this.total = res.data.count;
          if (res.data.hasOwnProperty("objects")) {
            this.inviteList = this.inviteList.concat(res.data.objects);
            this.len = this.inviteList.length;
          }
        })
        .finally(() => {
          this.isDownLoading = false;
          this.isUpLoading = false;
        });
    },
    // 下拉刷新
    onDownRefresh() {
      this.inviteList = [];
      this.pageIndex = 1;
      this.upFinished = false; // 不写这句会导致你上拉到底过后在下拉刷新将不能触发下拉加载事件
      this.getroadList(); // 加载数据
    },
    // 上拉加载请求方法
    onLoadList() {
      if (this.total > this.pageIndex * this.pageSize) {
        this.pageIndex++;
        this.getroadList();
      } else {
        this.upFinished = true;
      }
    },
  },
  components: {
    NoPic,
  },
};
</script>

<style lang="less" scoped>
@import "~Style/index.less";
.back {
  width: 22px;
  height: 23px;
  background-repeat: no-repeat;
  background-size: contain;
  position: absolute;
  left: 5px;
  top: 5px;
  z-index: 100;
}
.invite_save_box {
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 20;

  .invite_save_box_center {
    .w(375);
    height: 543px;
    background-color: #fff;
    border-radius: 32px;
    margin: 44px auto 0;
    padding: 17px 16px 0;

    .showSave_logo {
      text-align: center;
      line-height: 23px;
      margin-top: 28px;

      img {
        margin-right: 5px;
        vertical-align: top;
      }

      span {
        font-size: 18px;
        font-weight: bold;
      }
    }
  }
}

.myInvite {
  .saveDiv {
    .w(336);
    border: solid 1px #d6d6d6;
    border-radius: 25px;
    margin: 0 auto;
    margin-top: 17px;
  }

  .saveBTN {
    margin-top: 0;
    margin-bottom: 20px;
    width: 80%;
  }

  .qrcode {
    display: inline-block;
    margin-left: -20px;
    border: solid 5px #000;
    padding: 5px;
    border-radius: 15px;
    // width: 50%;
    background: white;
    width: 160px;
    height: 160px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 21px;
  }

  .vaSup {
    vertical-align: super;
    font-weight: bolder;
  }

  .vaSub {
    vertical-align: sub;
  }

  .content {
    input {
      // margin-left: 10%;
      // width: 60%;
      text-align: center;
      border-radius: 18px;
      // line-height: 1rem;
      // width: 70%;
      background-color: #eceff5;
      // border: 1px solid #ededed;
      border: none;
    }
  }

  .code {
    width: 60%;
    margin: 20px auto 0;
    height: 1rem;
    vertical-align: middle;
    border-style: solid;
    text-align: center;
    border-width: 1px;
    font-weight: bold;
    border-color: #d6d6d6;
    line-height: 1rem;
    letter-spacing: 0.2px;
  }

  .rightIcon {
    position: absolute;
    left: 252px;
    top: 12px;
    width: 20px;
    height: 20px;
    // display: inline-block;
    background-color: green;
    border-radius: 10px;
    color: white;
    // float: right;
    // margin-top: -0.7rem;
    // margin-right: 0.7rem;
  }

  .list {
    img {
      width: 2rem;
      border: 1px solid #fff;
      border-radius: 50%;
    }

    p {
      float: right;
      width: 70%;
      margin-top: 0.6rem;
    }

    hr {
      width: 90%;
      margin-left: 5%;
    }
  }

  .content_invite {
    font-size: 18px;
    margin-top: 21px;
    // margin-left:-3px;
    margin-left: 29px;
    font-weight: bolder;
  }

  .imgBox {
    .w(160);
    height: 205px;
    display: flex;
    justify-content: center;
    align-items: center;

    img {
      width: 155px;
      height: 157px;
    }
  }

  .saveDiv_Invit_box {
    display: flex;
    justify-content: center;
  }
}

.invite_box {
  padding: 21px 16px 0;
}

.invite_userinfo {
  display: flex;
  justify-content: space-between;

  .invite_userinfo_left {
    display: flex;
    align-items: center;

    .invite_userinfo_av {
      .w(55);
      height: 55px;
      margin-right: 6px;

      img {
        width: 100%;
        height: 100%;
        border-radius: 55px;
      }
    }

    .invite_userinfo_name {
      font-size: 18px;
    }
  }

  .invite_userinfo_right {
    margin-right: 20px;
    margin-top: 17px;
    width: 65px;
    height: 28px;
    background: #ffffff;
    border-radius: 2px;
    border: 1px solid #000000;
    display: flex;
    align-items: center;
    justify-content: center;

    img {
      width: 20px;
      height: 20px;
    }
  }
}

.invite_code_box {
  .w(320);
  height: 378px;
  border-top: 1px solid #eaeaea;
  border-bottom: 1px solid #eaeaea;
  margin: 0 auto;
  padding-top: 24px;
  margin-top: 19px;

  .invite_code {
    margin: 0 auto;
    .w(293);
    height: 293px;
    border: 10px solid #000;
    border-radius: 18px;
    padding: 10px;
    display: flex;
    align-items: center;
    vertical-align: center;
    text-align: center;

    img {
      width: 100%;
      height: 100%;
    }
  }

  .invite_code_de {
    font-size: 12px;
    color: #9b9b9b;
    text-align: center;
    margin-top: 12px;
  }
}

.content {
  display: flex;
  margin-top: 33px;
  font-size: 18px;
  position: relative;

  .content_Icode {
    .w(208);
    // height:47px;
    margin-right: 10px;
    margin-left: 15px;
  }

  .content_copy {
    .w(63);
    border-radius: 5px;
    color: #fff;
  }
}
</style><style lang="less">
@import "~Style/index.less";

.myInvite {
  .van-tab {
    background-color: #eceff5;
  }

  .van-tabs__line {
    background-color: #000;
    /*width: 100%;*/
  }
}
</style>
